// API configuration
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// R2 CDN for card images
export const R2_IMAGE_URL = 'https://pub-26ec8d38feac4530a1f9a87c80ab3cf9.r2.dev';

export default API_URL;
